import { transportTimeoutMs } from '../helpers/transport-timeout.helpers';
import { withTimeout } from '../helpers/with-timeout.helpers';

// Safari 12 lacks Intl.PluralRules, so its plural copy (the score-loss warnings among it) renders as raw ICU.
// The polyfill also needs Intl.Locale. Plain checks keep locale-matching code out of every other browser's bundle.
export const loadIntlPolyfills = (): Promise<void> => {
  if ('PluralRules' in Intl) return Promise.resolve();
  const loads = Promise.all([
    'Locale' in Intl ? undefined : import('@formatjs/intl-locale/polyfill-force'),
    import('./intl-pluralrules-polyfill'),
  ]).then(() => undefined);
  const timeoutMs = transportTimeoutMs('default');
  // Bounded because the first render waits on it; past the bound the app renders without plural copy.
  return withTimeout(loads, timeoutMs, () => new Error(`Intl polyfills did not load within ${timeoutMs}ms`));
};
